// import Link from 'next/link';

import {
  Container,
  FooterBottomLeft,
  // FooterBottomMiddle,
  FooterBottomRight,
  Wrapper,
} from './styles';

const FooterBottom = (): JSX.Element => {
  return (
    <Container>
      <Wrapper>
        <FooterBottomLeft>
        Copyright © 2026 DELPS TRANSPORTES E LOGISTICA LTDA. CNPJ: 03.673.321/0001-45
        </FooterBottomLeft>
        {/* <FooterBottomMiddle className="desktop">
          <Link href="/termos-de-uso" passHref legacyBehavior>
            <a>Termos de Uso</a>
          </Link>
          <hr />
          <Link href="/politicas-de-privacidade" passHref legacyBehavior>
            <a>Políticas de privacidade</a>
          </Link>
        </FooterBottomMiddle> */}
        <FooterBottomRight>
          Desenvolvido por{' '}
          <a href="https://sacflow.com.br" target="_blank" rel="noreferrer">
            Sacflow
          </a>
        </FooterBottomRight>
      </Wrapper>
    </Container>
  );
};

export default FooterBottom;
